import React, { useState, useEffect } from 'react';
import supabase from './supabaseClient';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [sellerSession, setSellerSession] = useState(null);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => setSellerSession(session));
    supabase.auth.onAuthStateChange((_event, session) => setSellerSession(session));
  }, []);
  const handleSellerLogout = async () => {
    await supabase.auth.signOut();
    setSellerSession(null);
  };

  const isMobile = window.innerWidth <= 600;

  return (
    <header style={{
      background: '#f7f3ec',
      borderBottom: '1px solid rgba(44,74,46,0.1)',
      boxShadow: '0 2px 16px rgba(44,74,46,0.08)',
      padding: '0 16px',
      position: 'sticky',
      top: 0,
      zIndex: 999,
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '64px',
      }}>

        {/* Logo Text */}
        <div onClick={() => navigate('/')} style={{ cursor: 'pointer', flexShrink: 0 }}>
          <div style={{
            fontFamily: 'Playfair Display, Georgia, serif',
            fontSize: isMobile ? '16px' : '22px',
            fontWeight: 700,
            color: '#1e3d20',
            lineHeight: 1.1,
            whiteSpace: 'nowrap',
          }}>
            True Plant Value
          </div>
          <div style={{
            fontFamily: 'Lato, Arial, sans-serif',
            fontSize: '8px',
            letterSpacing: '3px',
            color: '#4a7c59',
            textTransform: 'uppercase',
            marginTop: '2px',
            whiteSpace: 'nowrap',
          }}>
            Rooted in Fair Value
          </div>
        </div>

        {/* Desktop Nav */}
        {!isMobile && (
          <nav style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <button onClick={() => navigate('/about')} style={{ background: 'transparent', border: 'none', color: '#2c4a2e', fontFamily: 'Lato, sans-serif', fontSize: '13px', fontWeight: 700, letterSpacing: '1px', cursor: 'pointer', padding: '8px 14px', borderRadius: '20px', textTransform: 'uppercase' }}
              onMouseEnter={(e) => e.target.style.background = 'rgba(44,74,46,0.08)'}
              onMouseLeave={(e) => e.target.style.background = 'transparent'}
            >About</button>
            <button onClick={() => navigate('/blog')} style={{ background: 'transparent', border: 'none', color: '#2c4a2e', fontFamily: 'Lato, sans-serif', fontSize: '13px', fontWeight: 700, letterSpacing: '1px', cursor: 'pointer', padding: '8px 14px', borderRadius: '20px', textTransform: 'uppercase' }}
              onMouseEnter={(e) => e.target.style.background = 'rgba(44,74,46,0.08)'}
              onMouseLeave={(e) => e.target.style.background = 'transparent'}
            >Blog</button>
            <button onClick={() => navigate('/')} style={{ background: 'transparent', border: 'none', color: '#2c4a2e', fontFamily: 'Lato, sans-serif', fontSize: '13px', fontWeight: 700, letterSpacing: '1px', cursor: 'pointer', padding: '8px 14px', borderRadius: '20px', textTransform: 'uppercase' }}
              onMouseEnter={(e) => e.target.style.background = 'rgba(44,74,46,0.08)'}
              onMouseLeave={(e) => e.target.style.background = 'transparent'}
            >Home</button>
            {!sellerSession && (
              <>
                <button onClick={() => navigate('/submit')} style={{ background: 'transparent', border: '2px solid #4a7c59', color: '#2c4a2e', fontFamily: 'Lato, sans-serif', fontSize: '12px', fontWeight: 700, letterSpacing: '1px', cursor: 'pointer', padding: '8px 16px', borderRadius: '20px', textTransform: 'uppercase' }}
                  onMouseEnter={(e) => { e.target.style.background = '#4a7c59'; e.target.style.color = '#f5f0e8'; }}
                  onMouseLeave={(e) => { e.target.style.background = 'transparent'; e.target.style.color = '#2c4a2e'; }}
                >Submit Sale</button>
                <button onClick={() => navigate('/spotted')} style={{ background: 'transparent', border: '2px solid #8b6914', color: '#8b6914', fontFamily: 'Lato, sans-serif', fontSize: '12px', fontWeight: 700, letterSpacing: '1px', cursor: 'pointer', padding: '8px 16px', borderRadius: '20px', textTransform: 'uppercase' }}
                  onMouseEnter={(e) => { e.target.style.background = '#8b6914'; e.target.style.color = '#f5f0e8'; }}
                  onMouseLeave={(e) => { e.target.style.background = 'transparent'; e.target.style.color = '#8b6914'; }}
                >Spotted in the Wild 🔍</button>
              </>
            )}
            <button onClick={() => navigate('/for-sale')} style={{ background: 'transparent', border: '2px solid #8b6914', color: '#8b6914', fontFamily: 'Lato, sans-serif', fontSize: '12px', fontWeight: 700, letterSpacing: '1px', cursor: 'pointer', padding: '8px 16px', borderRadius: '20px', textTransform: 'uppercase' }}
              onMouseEnter={(e) => { e.target.style.background = '#8b6914'; e.target.style.color = '#f5f0e8'; }}
              onMouseLeave={(e) => { e.target.style.background = 'transparent'; e.target.style.color = '#8b6914'; }}
            >For Sale 🌿</button>
            <button onClick={() => navigate(sellerSession ? '/seller/dashboard' : '/seller/login')} style={{ background: 'transparent', border: '2px solid #2c4a2e', color: '#2c4a2e', fontFamily: 'Lato, sans-serif', fontSize: '12px', fontWeight: 700, letterSpacing: '1px', cursor: 'pointer', padding: '8px 16px', borderRadius: '20px', textTransform: 'uppercase' }}
              onMouseEnter={(e) => { e.target.style.background = '#2c4a2e'; e.target.style.color = '#f5f0e8'; }}
              onMouseLeave={(e) => { e.target.style.background = 'transparent'; e.target.style.color = '#2c4a2e'; }}
            >{sellerSession ? 'My Dashboard' : 'Member Login'}</button>
            {sellerSession && (
              <button onClick={handleSellerLogout} style={{ background: 'transparent', border: '2px solid #c0392b', color: '#c0392b', fontFamily: 'Lato, sans-serif', fontSize: '12px', fontWeight: 700, letterSpacing: '1px', cursor: 'pointer', padding: '8px 16px', borderRadius: '20px', textTransform: 'uppercase' }}
                onMouseEnter={(e) => { e.target.style.background = '#c0392b'; e.target.style.color = '#f5f0e8'; }}
                onMouseLeave={(e) => { e.target.style.background = 'transparent'; e.target.style.color = '#c0392b'; }}
              >Log Out</button>
            )}
            <button onClick={() => navigate('/search')} style={{ background: 'linear-gradient(135deg, #2c4a2e, #4a7c59)', border: 'none', color: '#f5f0e8', fontFamily: 'Lato, sans-serif', fontSize: '12px', fontWeight: 700, letterSpacing: '1px', cursor: 'pointer', padding: '9px 18px', borderRadius: '20px', textTransform: 'uppercase' }}
              onMouseEnter={(e) => e.target.style.opacity = '0.85'}
              onMouseLeave={(e) => e.target.style.opacity = '1'}
            >Search Plants</button>
          </nav>
        )}

        {/* Mobile Hamburger */}
        {isMobile && (
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            style={{ background: 'transparent', border: 'none', cursor: 'pointer', fontSize: '24px', color: '#1e3d20', padding: '8px' }}
          >
            {menuOpen ? '✕' : '☰'}
          </button>
        )}
      </div>

      {/* Mobile Menu */}
      {isMobile && menuOpen && (
        <div style={{ background: '#f7f3ec', borderTop: '1px solid rgba(44,74,46,0.1)', padding: '16px' }}>
          {[
            { label: 'Home', path: '/' },
            { label: 'Search Plants', path: '/search' },
            { label: 'For Sale 🌿', path: '/for-sale' },
            ...(!sellerSession ? [{ label: 'Submit Sale', path: '/submit' }, { label: 'Spotted in the Wild 🔍', path: '/spotted' }] : []),
            { label: 'Blog', path: '/blog' },
            { label: 'About', path: '/about' },
            { label: sellerSession ? 'My Dashboard' : 'Member Login', path: sellerSession ? '/seller/dashboard' : '/seller/login' },
          ].map(({ label, path }) => (
            <button
              key={label}
              onClick={() => { navigate(path); setMenuOpen(false); }}
              style={{
                display: 'block', width: '100%', textAlign: 'left',
                background: 'transparent', border: 'none', padding: '12px 8px',
                fontFamily: 'Lato, sans-serif', fontSize: '16px', fontWeight: 700,
                color: '#1e3d20', cursor: 'pointer', borderBottom: '1px solid rgba(44,74,46,0.08)',
                letterSpacing: '1px',
              }}
            >
              {label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};

export default Header;